/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
import { DropdownButton, MenuItem } from 'react-bootstrap';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Finder from './Finder';
import { incrementBounceCounter } from '../../actions/style';
import s from './SearchBox.scss';

import { districtsWithGraveyards } from '../../constants';

const mapState = state => ({
  bounceCounter: state.style.bounceCounter,
  district: state.district.district,
  searchboxStatus: state.style.searchboxStatus,
});

const mapDispatch = {
  incrementBounceCounter,
};

@connect(
  mapState,
  mapDispatch,
)
class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchLayers: [
        {
          name: 'Działki',
          glyph: 'glyphicon glyphicon-screenshot',
        },
        {
          name: 'POI',
          glyph: 'glyphicon glyphicon-map-marker',
        },
      ],
      selectedLayerIndex: 0,
      dzialki: '',
      isDzialkiFetched: false,
      chosenParcel: {},
    };

    this.onDropdownSelect = this.onDropdownSelect.bind(this);
    this.fetchDzialki = this.fetchDzialki.bind(this);
  }
  componentDidMount = () => {
    if (!districtsWithGraveyards.includes(this.props.district.prefix)) {
      this.fetchDzialki();
    }
  };

  onDropdownSelect = e => {
    this.setState({
      selectedLayerIndex: e,
    });
  };

  fetchDzialki = () => {
    const p2 = `${process.env.API_URL}/district/${this.props.district.prefix}/parcels`;

    fetch(p2, {
      type: 'GET',
    })
      .then(resp => resp.json())
      .then(r => {
        this.setState({ dzialki: r, isDzialkiFetched: true });
      });
  };
  chosenParcel = e => {
    this.setState({ chosenParcel: e });
  };

  render() {
    return this.props.district && this.props.district.prefix ? (
      districtsWithGraveyards.includes(this.props.district.prefix))
      ? null
      : (
        <div className={'searchBox'}>
          {this.state.isDzialkiFetched ? (
            <div className={'searchGroup'}>
              <ReactCSSTransitionGroup
                transitionName={this.props.bounceCounter > 2 ? 'fade' : 'bounce'}
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}
              >
                {/* <Finder chosenParcel={this.chosenParcel} dzialki={this.state.dzialki} /> */}
                <Finder />
              </ReactCSSTransitionGroup>
            </div>
          ) : (
            <div className={'searchGroup'} style={{ visibility: 'hidden' }} />
          )}
        </div>
      ) : null;
  }
}

export default withStyles(s)(SearchBox);



// WEBPACK FOOTER //
// src/components/SearchBox/SearchBox.js